function sidebarTemplate(active) {
	return Helper.template.sidebarNav([
		{
			content: `<span class="list-label"><i class="ph ph-cpu"></i> Scopes</span>`,
			route: "/#!/scripts/scopes",
			is_active: active == "scopes"
		},
		{
			content: `<span class="list-label"><i class="ph ph-play"></i> Actions</span>`,
			route: "/#!/scripts/actions",
			is_active: active == "actions"
		},
		{
			content: `<span class="list-label"><i class="ph ph-magnifying-glass"></i> Regular</span>`,
			route: "/#!/scripts/regular",
			is_active: active == "regular"
		}
	]);
}

export {
	sidebarTemplate
}